// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--Vegx5","text":"dece2e673c--text--j0XQa"};